import type { ReactNode } from 'react';

import { parseMinimalMarkdown } from '@/hen-ui/lib/minimal-markdown';

export type TooltipContentFormat = 'plain' | 'markdown';

export type ResolvedTooltipBody =
  | { format: 'plain'; text: string }
  | { format: 'markdown'; nodes: ReactNode[] };

export function resolveTooltipBody(
  content: string,
  format: TooltipContentFormat = 'plain',
): ResolvedTooltipBody {
  const trimmed = content.trim();
  if (format === 'markdown') {
    return { format: 'markdown', nodes: parseMinimalMarkdown(trimmed) };
  }
  return { format: 'plain', text: trimmed };
}
